// src/components/FipiPublication.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

import "../style/FipiPublication.css";

import PolicyReport from "../assets/images/i/Policy Report.jpeg";
import Journal from "../assets/images/i/Journal.jpeg";
import reportImg from "../assets/images/i/annual-report.jpeg";
const FipiPublication = () => {
  const navigate = useNavigate();

  return (
    <div className="fipi-publication">
      {/* ===== HEADER / BACK BUTTON ===== */}
      <div className="fipi-publication-header">
        <button
          className="clear-filters-btn"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>
      </div>

      {/* ===== CARD GRID ===== */}
      <div className="fipi-publication-grid">
        {/* Card 1 */}
       <div
          className="card"
          onClick={() =>
            window.open("https://www.fipi.org.in/policy-economic.php", "_blank")
          }
          style={{ cursor: "pointer" }}
        >
          <img src={PolicyReport} alt="Policy Economic Report" />
          <h3>Monthly Policy Economic Report</h3>
          
          <div className="card-link">
            <a href="#!" onClick={(e) => e.preventDefault()}>
              Explore More Contents
            </a>
          </div>
        </div>

        {/* Card 2 */}
        <div
          className="card"
          onClick={() =>
            window.open("https://www.fipi.org.in/fipi-journal.php", "_blank")
          }
          style={{ cursor: "pointer" }}
        >
          <img src={Journal} alt="Journal" />
          <h3>Quarterly Journal</h3>
         
          <div className="card-link">
            <a href="#!" onClick={(e) => e.preventDefault()}>
              Explore More Contents
            </a>
          </div>
        </div>

        {/* Card 3 */}
        <div className="card"
          onClick={() =>
            window.open("https://www.fipi.org.in/assets/pdf/Annual_Report2024-25.pdf", "_blank")
          }
        >
          <img src={reportImg} alt="Annual Reports" />
          <h3>Annual Reports</h3>
          {/* <div className="card-content">
            <ul>
              <li>Yearly Performance</li>
              <li>Key Highlights</li>
              <li>Future Roadmap</li>
            </ul>
          </div> */}
          <div className="card-link">
            <a href="#!" onClick={(e) => e.preventDefault()}>
              Explore More Contents
            </a>
          </div>
        </div>
      </div>
    </div> 
  );
};

export default FipiPublication;
